import React, { useEffect, useRef, useState } from 'react'
import { sortByEnums } from '..'
import styled, { keyframes } from 'styled-components'
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`
const SortByButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: ${({ theme }) => theme.bg0};
  transition: all 300ms;

  svg {
    stroke: rgb(195, 197, 203);
  }

  &:hover {
    background: ${({ theme }) => theme.bg1};
  }
`
const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`

const DropdownMenu = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  background: ${({ theme }) => theme.bg2};
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 116px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
  animation: ${fadeIn} 0.3s ease-out;
  margin-top: 6px;
  padding: 8px;
  border-radius: 12px;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
`
const DropdownMenuInner = styled.div`
  display: flex;
  flex-direction: column;
`
const DropdownMenuEntry = styled.button<{ active: boolean }>`
  all: unset;
  cursor: pointer;
  padding: 8px;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme, active }) => (active ? theme.text1 : theme.text2)};
  display: flex;
  gap: 6px;
  align-items: center;
`

interface SortByProps {
  sortBy: sortByEnums
  setSortBy: (value: sortByEnums) => void
}

const SortBy: React.FC<SortByProps> = ({ sortBy, setSortBy }) => {
  const [isVisible, setIsVisible] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const toggleDropdown = () => setIsVisible((prev) => !prev)

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsVisible(false)
    }
  }
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const hasIcon = (value: sortByEnums) => {
    return sortBy === value ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#4AFB39"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-arrows-sort"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 9l4 -4l4 4m-4 -4v14" />
        <path d="M21 15l-4 4l-4 -4m4 4v-14" />
      </svg>
    ) : (
      <></>
    )
  }

  const handleSelect = (value: sortByEnums) => {
    setSortBy(value)
    toggleDropdown()
  }

  return (
    <DropdownContainer ref={dropdownRef}>
      <SortByButton onClick={toggleDropdown}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-sort-descending"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M4 6l9 0" />
          <path d="M4 12l7 0" />
          <path d="M4 18l7 0" />
          <path d="M15 15l3 3l3 -3" />
          <path d="M18 6l0 12" />
        </svg>
      </SortByButton>
      <DropdownMenu isVisible={isVisible}>
        <DropdownMenuInner>
          <DropdownMenuEntry onClick={() => handleSelect('tvl')} active={sortBy === 'tvl'}>
            {hasIcon('tvl')}TVL
          </DropdownMenuEntry>
          <DropdownMenuEntry onClick={() => handleSelect('volume')} active={sortBy === 'volume'}>
            {hasIcon('volume')}Volume
          </DropdownMenuEntry>
          <DropdownMenuEntry onClick={() => handleSelect('apr')} active={sortBy === 'apr'}>
            {hasIcon('apr')}APR
          </DropdownMenuEntry>
        </DropdownMenuInner>
      </DropdownMenu>
    </DropdownContainer>
  )
}
export default SortBy
